// Polyfill for Symbol.observable
if (!Symbol.observable) {
  Object.defineProperty(Symbol, "observable", {
    value: Symbol("observable"),
    configurable: true,
    enumerable: false,
    writable: false,
  });
}
